module.exports = __webpack_public_path__ + "img/check-error.3ae20e1f.svg";